import * as React from 'react';

import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {TextField} from 'shells/textfield/textfield';

import styles from './editor.module.css';

type Props = {
    fontSize: number;
    placeholderStyles: any;
    width?: number;
};

export function LoadingField(props: Props) {
    return (
        <div className={styles.loading}>
            <label htmlFor=''>
                <LoadingText
                    minWidth={props.width ?? 100}
                    maxWidth={props.width ?? 200}
                    height={props.fontSize}
                />
            </label>
            <TextField
                value=''
                // @ts-expect-error
                style={{...props.placeholderStyles, marginTop: '8px'}}
                onChange={() => {}}
            />
        </div>
    );
}
